var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScale = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9.164 4.576 2h.006l.01.017 14.871-.015.001-.002h.007L24 9.164c0 2.382-2.045 4.323-4.556 4.323-2.51 0-4.555-1.94-4.555-4.323l3.632-5.686-5.744.005V16.25L18.149 22H5.857l5.366-5.71V3.485l-5.699.006 3.587 5.673c0 2.382-2.045 4.323-4.555 4.323S0 11.547 0 9.164ZM6.355 7.69 4.57 4.86h-.007L2.756 7.69h3.6ZM1.554 9.17c0 1.57 1.341 2.843 2.995 2.843h.007c1.647 0 2.995-1.273 2.995-2.842H1.554Zm17.904-4.31 1.786 2.83h-3.6l1.807-2.83h.007Zm-.02 7.153c-1.654 0-2.995-1.273-2.995-2.842h5.996c0 1.569-1.348 2.842-2.995 2.842h-.006ZM9.33 20.526h5.366l-2.676-2.861-2.69 2.86Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Scale.f1c170ad5f3b7840ba0459707804822a.svg";